/**
 *	The portal's `localStorage` namespace. One instance, re-exported, so every
 *	call site shares the same `tsdp::` prefix — see @shared/storage/local for
 *	why the prefix is per-app rather than baked into the shared module.
 */
import { createLocalStorage } from '@shared/storage/local';

export const storage = createLocalStorage('tsdp');
